var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 69,
    viewBox: "0 0 48 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_2952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33281 26.342L0 30.6748L1.28516 31.96L2.57031 33.2451L4.68164 31.1338L6.79297 29.0225V32.9238C6.79297 35.0719 6.83887 37.2199 6.88477 37.6973C7.19687 40.6072 8.43613 43.2969 10.4373 45.3623C10.7311 45.6744 12.8057 47.5195 15.0547 49.4656C17.8729 51.9166 19.2865 53.2109 19.6262 53.6424C20.1953 54.3859 20.7645 55.4508 21.0766 56.3596C21.5447 57.7273 21.5723 58.1588 21.5723 63.7768V69H23.399H25.235L25.2625 63.5105L25.2992 58.0303L25.5379 57.1582C25.9602 55.6068 26.7037 54.2482 27.7043 53.1834C27.998 52.8805 30.0451 51.0537 32.2666 49.126C34.4881 47.2074 36.5627 45.3256 36.884 44.9584C37.6918 44.0221 38.3252 43.0582 38.8393 41.975C39.3533 40.8826 39.5002 40.4512 39.8215 39.166C40.051 38.2113 40.051 38.1746 40.0877 33.6215L40.1244 29.0408L42.2357 31.143L44.3379 33.2451L45.6414 31.9324L46.9541 30.6289L42.6396 26.3145L38.3252 22L33.9924 26.3328L29.6504 30.6748L30.9355 31.96L32.2207 33.2451L34.332 31.1338L36.4525 29.0225L36.4158 33.4746C36.3883 37.6881 36.3791 37.9635 36.1955 38.6336C35.7549 40.1941 34.993 41.6078 34.0291 42.6359C33.7629 42.9113 31.725 44.7289 29.4943 46.6658C25.29 50.3193 24.8311 50.76 23.9865 51.9533C23.7111 52.3389 23.4725 52.6602 23.4541 52.6602C23.4357 52.6602 23.1971 52.3297 22.9125 51.9258C22.0863 50.7508 21.4621 50.1541 17.1936 46.4547C14.9629 44.5178 12.9617 42.7186 12.7322 42.4523C11.7133 41.2314 11.0707 39.9555 10.676 38.3398C10.5566 37.8533 10.5291 36.9537 10.4924 33.3828L10.4557 29.0225L12.567 31.1338L14.6875 33.2451L15.991 31.9324L17.3037 30.6289L12.9893 26.3145L8.6748 22L4.33281 26.342Z",
    fill: "#666666"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_262_2952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5C9.78819 9.5 11.0236 8.99956 11.9345 8.10876C12.8454 7.21796 13.3571 6.00978 13.3571 4.75C13.3571 3.49022 12.8454 2.28204 11.9345 1.39124C11.0236 0.500445 9.78819 0 8.5 0C7.21181 0 5.97637 0.500445 5.06548 1.39124C4.15459 2.28204 3.64286 3.49022 3.64286 4.75C3.64286 6.00978 4.15459 7.21796 5.06548 8.10876C5.97637 8.99956 7.21181 9.5 8.5 9.5ZM6.76585 11.2812C3.02813 11.2812 0 14.2426 0 17.8979C0 18.5064 0.504688 19 1.12701 19H15.873C16.4953 19 17 18.5064 17 17.8979C17 14.2426 13.9719 11.2812 10.2342 11.2812H6.76585Z",
    fill: "#828284"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_262_2952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 9.5C40.364 9.5 41.6721 8.99956 42.6365 8.10876C43.601 7.21796 44.1429 6.00978 44.1429 4.75C44.1429 3.49022 43.601 2.28204 42.6365 1.39124C41.6721 0.500445 40.364 0 39 0C37.636 0 36.3279 0.500445 35.3635 1.39124C34.399 2.28204 33.8571 3.49022 33.8571 4.75C33.8571 6.00978 34.399 7.21796 35.3635 8.10876C36.3279 8.99956 37.636 9.5 39 9.5ZM37.1638 11.2812C33.2063 11.2812 30 14.2426 30 17.8979C30 18.5064 30.5344 19 31.1933 19H46.8067C47.4656 19 48 18.5064 48 17.8979C48 14.2426 44.7938 11.2812 40.8362 11.2812H37.1638Z",
    fill: "#828284"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_2952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_262_2952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_262_2952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white",
    transform: "translate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit2);
export default __webpack_public_path__ + "static/media/split_2.3fb7d676d1d84062c649a2b35753a024.svg";
export { ForwardRef as ReactComponent };